import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import { allAnnonceType, annonceGetById } from "../../../Redux/annonceReduce";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { toast, ToastContainer } from "react-toastify";
import { verification } from "../../../Redux/usersReduce";
import Configuration from "../../../configuration";

// core components
function DetailsActualite({client}) {
  const t = useTranslation();
  document.title = t("Actualite.mes");
  const dispatch = useDispatch();
  const navigate = useHistory();
  const location = useParams();
  var id = location.id;
  let lang = window.localStorage.getItem("lang");
  var annee = localStorage.getItem("annee");
  const [titre, setTitre] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [descriptionEn, setDescriptionEn] = React.useState("");
  const [titreEn, setTitreEn] = React.useState("");
  const [datePub, setDatePub] = React.useState(null);
  const [order, setOrder] = React.useState(0);
  const [type, setType] = React.useState(null);
  const [fileNames, setFileNames] = React.useState(null);
  const [codePct, setCodePct] = React.useState(null);
  const [codeArticle, setCodeArticle] = React.useState(null);
  const [prix, setPrix] = React.useState(null);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>
          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>
          {msg}
        </strong>
      );
  };

  function formatDateDifference(dateString) {
    const currentDate = new Date();
    const publishedDate = new Date(dateString);

    const timeDifference = currentDate - publishedDate;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (daysDifference === 0) {
      return t('Today');
    } else if (daysDifference === 1) {
      return t('Yesterday');
    } else {
      return t('daysAgo', { days: daysDifference });
    }
  }







  const verifToken = useCallback(async () => {
    try {
      await dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  function listeActualite() {
    navigate.goBack();
  }

  useEffect(() => {
    verifToken()
    async function getActualite() {
      if (isNaN(location.id) === false) {
        var actualite = await dispatch(annonceGetById(location.id));
        var entities = actualite.payload;
        if (entities === false) {
          navigate.push(client+'/listActualite');
        }
        else {
          setDatePub(entities.date_pub);
          setFileNames(entities.image);
          setOrder(entities.order);
          setTitre(entities.titre);
          setTitreEn(entities.titreEn);
          setDescription(entities.description);
          setType(entities.id_type);
          setPrix(entities.prix);
          setCodePct(entities.code_pct);
          setCodeArticle(entities.code_article);
          setDescriptionEn(entities.description_en);
        }
      }
    }
    getActualite();
  }, [location.id, dispatch, navigate]);
  return (
    <>
      <Container fluid className="style-actualita">
        <ToastContainer />

        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={listeActualite}
            >
              <span className="btn-label">
                <i className="fas fa-list"></i>
              </span>
              {t('list')}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("details")}</Card.Title>
              </Card.Header>
              <Card.Body className="padding-0 details-actualite">
                <div className="list-table-container">
                  <div key={id} className="list-item">
                    <div className="left-content">
                      {fileNames && (
                        <img
                          className="image-product"
                          src={Configuration.BACK_BASEURL + "annonce/" + fileNames}
                          alt={titre}
                        />
                      )}
                    </div>
                    {type == 1 || type == 3 ?
                      <div className="right-content">
                        <div className="logo">
                          <div className="titre-article groupe-logo" >
                            {/* <img
                    src={require("../../../assets/img/logo-actualite.png")}
                    alt="recordati"
                    className="logo-recordati"
                  /> */}
                           {client.replace('/','').toUpperCase()}
                          </div>
                          <div className="date-pub">{formatDateDifference(datePub)}</div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="titre-article">{lang == "en" ? titreEn : titre}</div>
                        <div className="description-article">
                          {lang === "en" ? descriptionEn : description}
                        </div>

                      </div> :

                      <div className="right-content">
                        <div className="logo clearfix">
                          <div className="titre-article clearfix groupe-logo">
                            {client.replace('/','').toUpperCase()}
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="titre-article">Designation : {titre}</div>
                        <div className="titre-article">Code Pct : {codePct}</div>
                        <div className="titre-article">Code Article : {codeArticle}</div>
                        <div className="titre-article">Prix : {prix}</div>

                      </div>}
                    <div className="clearfix"></div>
                  </div>   </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default DetailsActualite;
